import React from 'react'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

function Placard() {

    const { id, urlTitle } = useParams();

    const [documentData, setDocumentData] = useState([]);

    const getDocumentDetails = async () => {
        axios
            .get("/api/v1/documents/placard/" + id)
            .then((result) => {
                setDocumentData(result.data)
                console.log(result.data);
            })
            .catch((err) => console.log(err));
    };

    const generatePlacard = async () => {
        axios.get("/api/v1/documents/generatePlacard/" + id)
            .then((result) => alert(result.data))
            .catch((err) => alert('error'));
    };

    useEffect(() => {
        getDocumentDetails();
    }, [])


    return (
        <div>
            <div className="phone-preview-container">
                <center><h1>{documentData[0]}</h1></center>
                <center><p className="red">{documentData[1]}</p></center>
                <center><h2 className="topLine">RedSaysBlueSays.com</h2></center>
                <center><p className="bottomLine">add your voice</p></center>
                <center><p className="blue">{documentData[2]}</p></center>
                <br /><br />
            </div>
            <center><button onClick={() => generatePlacard()}>Generate Graphic</button></center>

        </div>
    )
}

export default Placard
